export const getDataTableConfiguration = (state, tableId) => {
    return tableId && state[tableId] && state[tableId].config;
};
export const getDataTableSelected = (state, tableId) => {
    return (tableId && state[tableId] && state[tableId].selected) || [];
};
export const getDataTableAll = (state, tableId) => {
    return (tableId && state[tableId] && state[tableId].all) || false;
};
//# sourceMappingURL=datatable.selector.js.map